import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class PowerIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 285.29 300">
                <g fill={color}>
                    <path d="M169.33 297.45a142.19 142.19 0 0 0 115.37-153c-3.05-33.9-16.89-63.53-41.14-88.07-6.1-6.17-13.4-7.94-21.7-5.27A21.05 21.05 0 0 0 207.51 66a23 23 0 0 0 5.93 21.51c28 29.84 35.72 64.29 23 102.41a96.92 96.92 0 0 1-46.27 54.86 100.33 100.33 0 0 1-71.64 8.93A97.56 97.56 0 0 1 74.04 229c-22.39-21.67-34.39-53.44-29.59-85.79 3.18-21.4 12.65-40.37 28.12-56.39A21.35 21.35 0 0 0 72.02 56c-8.82-8.4-22-8-30.62.85C13.94 85.12.78 118.71 0 162.54c.23 1.64.45 3.6.71 5.84a190.8 190.8 0 0 0 3.52 22.37 142 142 0 0 0 165.1 106.7z" />
                    <path d="M164.34 27.11v-2a38.5 38.5 0 0 0-.43-7.74A21.35 21.35 0 0 0 142.65 0a23.81 23.81 0 0 0-2.47.13c-10.65 1.11-18.8 10.29-19 21.37-.08 6.1-.06 12.32 0 18.34V162.58c0 12.13 9.23 21.79 21 22a21.8 21.8 0 0 0 15.73-6.14 21 21 0 0 0 6.32-15c.13-16.65.1-33.58.08-50V92.31l.05-15.87q.01-24.65-.02-49.33z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(PowerIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/PowerIcon.js